// Global stores registered on init
document.addEventListener('alpine:init', () => {
  Alpine.store('theme', {
    current: 'light',

    toggle() {
      if (this.current === 'light') { 
        this.current = 'dark'
      } else {
        this.current = 'light'
      }
    }
  });

  // Note: Feature Slider component is now loaded automatically from its local file
  // at views/components/organisms/feature-slider/feature-slider.js
});
